import React from 'react';
import { useTranslation } from 'react-i18next';

interface Theme {
  id: string;
  name: string;
  color: string;
}

interface ThemeSelectorProps {
  themesOptions: Theme[];
  themesSelected: string | null;
  isArchived?: boolean;
  toggleThemeSelection: ( themeId: string ) => void;
}

const ThemeSelector: React.FC<ThemeSelectorProps> = ( { themesOptions, isArchived, themesSelected, toggleThemeSelection } ) => {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-4 rounded-md">
        {themesOptions.length > 0 ? (
          themesOptions.map( theme => {
            const isSelected = themesSelected === theme.id;

            return (
              <button
                key={theme.id}
                onClick={
                  isArchived
                    ? undefined
                    : () => {return toggleThemeSelection( theme.id );}
                }
                className={`
                  px-4 bg-white border trans-fast overflow-hidden py-2 rounded-md relative transition-all
                  ${isSelected ? 'text-white' : 'text-gray-base-dark'}
                  ${isArchived && !isSelected ? 'opacity-50 cursor-default' : ''}
                `}
              >
                <div
                  className={`absolute z-0 left-2 trans-fast top-2 w-2 h-2 rounded-full ${
                    isSelected ? 'scale-[100]' : 'scale-100'
                  }`}
                  style={{ backgroundColor: theme.color }}
                />
                <p className="w-full h-full z-10 relative">{theme.name}</p>
              </button>
            );
          } )
        ) : (
          <p>{ t( 'translation:no_theme_available' ) }</p>
        )}
      </div>
    </div>
  );
};

export default ThemeSelector;
